module.exports = __webpack_public_path__ + "c2801fb415f03c7b170934769d7b5397.svg";